import Utils from "../../utils/Utils";
import App from "../../App";
import Layout from "../../utils/Layout";
import { IObjectConfig } from "../../baseConfigs/layoutConfigShema";
import { TextStyle, Container } from "pixi.js";
import MultiStyleText from "pixi-multistyle-text";
import { TextStyleSet } from "pixi-multistyle-text";
import BaseView from "../BaseView";

class BitmapTextField extends BaseView {
    static fontMeasure: any = {};
    protected _fieldWidth: number;
    protected _fieldHeight: number;
    public bound: IObjectConfig;
    public boundShape: PIXI.Graphics;
    public boundAnchor: {x: number, y: number} = {x: 0, y: 0};
    public initStyle: PIXI.extras.BitmapTextStyle;
    public scrollable: boolean = false;
    protected newStyle : PIXI.extras.BitmapTextStyle;
    protected _text: PIXI.extras.BitmapText;

    constructor(text: string, style: PIXI.extras.BitmapTextStyle , definition: { bound?: IObjectConfig , anchor?: {x: number, y: number}})
    {
        super(true);
        this.initStyle = {...style};
        this._text = new PIXI.extras.BitmapText(text, this.initStyle);

        this.addChild(this._text);
        this.boundAnchor = definition.anchor;
        if (definition.bound) {
            this.bound = definition.bound;
            this.applyBound();
        }
    }

    get anchor() {
        if (this._text.anchor instanceof PIXI.Point) {
            return this._text.anchor;
        } else {
            return new PIXI.Point(this._text.anchor);
        }
    }

    set anchor(anchor: PIXI.Point) {
        this._text.anchor = anchor;
        this.boundAnchor = anchor;
    }

       
    get element() {
        return this._text;
    }
    
    get characters() {
        return this._text.children;
    }

    get text(): string
    {
        return this._text.text;
    }

    set text(text: string)
    {
        text = String(text === '' || text === null || text === undefined ? ' ' : text);
        if (this._text.text === text)
        {
            return;
        }
        // this.dirty = true;
        this._text.text = text;
        this.applyBound();
    }

    set font(font: any ) {

        this._text.font = font.font ;
    }

    get font():any  {
        return this._text.font;
    }


    // public updateStyle( style: PIXI.extras.BitmapTextStyle) {
    //     this.newStyle = {...style};
    //     // TODO
    // }

    public applyBound() {
        if (!this.bound ) {
            return;
        }

        if (!this.boundShape) {
            this.boundShape = new PIXI.Graphics();
            this.boundShape.beginFill(0xFFFB1B, 0);
            this.boundShape.drawRect(0, 0, Layout.scalePixels(this.bound.width), Layout.scalePixels(this.bound.height));
            this.boundShape.endFill();
            this.addChild(this.boundShape);
        } else {
            Layout.testSetWidth(this.boundShape, this.bound.width, false);
            Layout.testSetHeight(this.boundShape, this.bound.height, false);
        }

        if (this.scrollable && !this.mask) {
            this.mask = this.boundShape;
        }


        const scaledWidth = Layout.scalePixels(this.bound.width);
        const scaledHeight = Layout.scalePixels(this.bound.height);
        this.scale.x = 1;
        this.scale.y = 1;
        this._text.scale.x = 1;
        this._text.scale.y = 1;


        if (this._text.width > scaledWidth) {
            Layout.testSetWidth(this._text, this.bound.width);
        }

        if (!this.scrollable && this._text.height > scaledHeight) {
            Layout.testSetHeight(this._text, this.bound.height);
        }

        // if (!this.scrollable && metrix.height > scaledHeight) {
        //     Layout.testSetHeight(this, this.bound.height);
        // }

        Layout.setY(this, this.bound.y);
        Layout.setX(this, this.bound.x );

        Layout.setY(this._text, this.boundAnchor.y * (this.bound.height ));
        Layout.setX(this._text, this.boundAnchor.x * (this.bound.width ));
    }
    
}

export default BitmapTextField